<template>
  <div style="border: 1px solid #ccc; width: 100%">
    <Toolbar
      style="border-bottom: 1px solid #dcdfe6; width: 100%; border-radius: 4px"
      :editor="editorRef"
      mode="default"
    />
    <Editor
      style="
        min-height: 300px;
        max-height: 1600px;
        overflow-y: hidden;
        width: 100%;
      "
      v-model="state.value"
      @onCreated="handleCreated"
      :default-config="editorConfig"
      @onChange="onChange"
    />
  </div>
</template>

<script>
import { onMounted, reactive, shallowRef, ref } from "vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { $http } from "@/http";
import { attachment_upload } from "@/http/attachment";

export default {
  props: {
    value: {
      type: String,
    },
  },
  components: {
    Editor,
    Toolbar,
  },
  setup(props, { emit }) {
    const state = reactive({});
    const editorRef = shallowRef();
    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };

    onMounted(() => {
      setTimeout(() => {
        state.value = props.value;
      }, 1500);
    });

    const editorConfig = ref({
      placeholder: "请填写内容...",
      width: "800px",
      readOnly: false, // 只读
      MENU_CONF: {
        // 配置上传图片
        uploadImage: {
          async customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append("file[]", file);
            attachment_upload(formData).then((res) => {
              if (res.status == 200) {
                const url =
                  $http.defaults.baseURL + res.data?.data[0]?.file_path;
                insertFn(url, "图片", url);
              }
            });
          },
        },
        uploadVideo: {
          async customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append("file", file);
            attachment_upload(formData).then((res) => {
              if (res.status == 200) {
                const url =
                  $http.defaults.baseURL + res.data?.data[0]?.file_path;
                insertFn(url);
              }
            });
          },
        },
      },
    });

    const onChange = (e) => {
      emit("change", e.getHtml());
    };

    return { state, props, handleCreated, editorRef, editorConfig, onChange };
  },
};
</script>
<style scoped></style>
